import { render, staticRenderFns } from "./GaleryRoomList.vue?vue&type=template&id=0a59a23c&scoped=true"
import script from "./GaleryRoomList.vue?vue&type=script&lang=js"
export * from "./GaleryRoomList.vue?vue&type=script&lang=js"
import style0 from "./GaleryRoomList.vue?vue&type=style&index=0&id=0a59a23c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a59a23c",
  null
  
)

export default component.exports